<admin-app-header></admin-app-header>
<div class="container-fluid">
    <div class="row my-3">
        <div class="col-md-12">
            <h2>{{ isEditMode ? 'Edit Cluster' : 'Create New Cluster' }}</h2>
        </div>
    </div>

    <div class="row">
        <div class="col-lg-8">
            <div class="card">
                <div class="card-body">
                    <form [formGroup]="clusterForm" (ngSubmit)="saveCluster()">
                        <!-- Title -->
                        <div class="form-group mb-3">
                            <label for="title">Title <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" id="title" formControlName="title" placeholder="e.g., Downtown Parking Options" />
                            <small class="form-text text-muted">Give your cluster a descriptive title</small>
                        </div>

                        <!-- Description -->
                        <div class="form-group mb-3">
                            <label for="description">Description</label>
                            <textarea class="form-control" id="description" formControlName="description" rows="3" placeholder="Optional description for this cluster"></textarea>
                            <small class="form-text text-muted">Add a brief description (optional)</small>
                        </div>

                        <!-- Logo Upload -->
                        <div class="form-group mb-3">
                            <label>Logo</label>
                            <div *ngIf="cluster?.logoUrl" class="mb-3">
                                <img [src]="cluster!.logoUrl" alt="Current Logo" class="img-thumbnail" style="max-height: 100px" />
                                <br />
                                <small class="text-muted">Current logo</small>
                                <br />
                                <button type="button" class="btn btn-outline-danger btn-sm mt-2" (click)="removeLogo()"><i class="fas fa-trash me-1"></i>Remove Logo</button>
                            </div>
                            <input type="file" class="form-control" (change)="onLogoSelected($event)" accept="image/*" />
                            <small class="form-text text-muted">Upload a logo image (PNG, JPG, SVG - max 5MB)</small>
                        </div>

                        <!-- Parking Selection -->
                        <div class="form-group mb-4">
                            <label for="parkings">Select Parkings <span class="text-danger">*</span></label>
                            <ng-select
                                [items]="parkings"
                                bindLabel="title"
                                bindValue="$key"
                                [multiple]="true"
                                placeholder="Select parkings"
                                [(ngModel)]="selectedParkings"
                                [ngModelOptions]="{ standalone: true }"
                            >
                                <ng-template ng-option-tmp let-item="item">
                                    <div>
                                        <strong>{{ item.title }}</strong>
                                        <br />
                                        <small class="text-muted">{{ item.parkingLocation?.city }}</small>
                                    </div>
                                </ng-template>
                            </ng-select>
                            <small class="form-text text-muted">Select one or more parkings to include in this cluster</small>
                        </div>

                        <!-- Action Buttons -->
                        <div class="d-flex justify-content-between">
                            <button type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="loading">Cancel</button>
                            <button type="submit" class="btn btn-primary" [disabled]="loading || clusterForm.invalid || selectedParkings.length === 0">
                                <span *ngIf="loading"><i class="fas fa-spinner fa-spin"></i> Saving...</span>
                                <span *ngIf="!loading"> <i class="fas fa-save"></i> {{ isEditMode ? 'Update Cluster' : 'Create Cluster' }} </span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <!-- Preview Panel -->
        <div class="col-lg-4">
            <div class="card">
                <div class="card-header">
                    <h5 class="mb-0">Preview</h5>
                </div>
                <div class="card-body">
                    <div class="preview-section">
                        <p><strong>Title:</strong> {{ clusterForm.value.title || 'Not set' }}</p>
                        <p><strong>Description:</strong> {{ clusterForm.value.description || 'None' }}</p>
                        <p><strong>Selected Parkings:</strong> {{ selectedParkings.length }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
